import PropTypes from 'prop-types';
import EstimateForm from '@chronos/components/EstimateForm';
import {
  useSaveEstimateMutation,
  useGetEstimatesQuery,
  useDeleteEstimateMutation,
} from '@chronos/slices/estimatesApi';
import { useBoardContext } from '@chronos/ui-toolkit/contexts';
import Modal from '@chronos/components/Modal';
import * as S from './styled';

const EstimateModal = (props) => {
  const boardContext = useBoardContext();
  const [saveEstimate, { isLoading: isSaving }] = useSaveEstimateMutation();

  const { data: estimates = [], isLoading: isEstimatesLoading } =
    useGetEstimatesQuery(
      {
        cardIds: [props.cardId],
      },
      {
        skip: !props.cardId,
      }
    );
  const [deleteEstimate, deleteResult] = useDeleteEstimateMutation();

  return (
    <Modal
      isOpen={props.isOpen}
      isSaving={isSaving}
      handleClose={props.handleClose}
      title="Set Estimate"
      isMobile
    >
      <S.Content>
        <EstimateForm
          estimates={estimates}
          isEstimatesLoading={isEstimatesLoading}
          deleteResult={deleteResult}
          deleteEstimate={deleteEstimate}
          handleSubmit={saveEstimate}
          users={props.users}
          isSaving={isSaving}
          cardId={props.cardId}
          userId={boardContext.userId}
          boardId={boardContext.boardId}
        />
      </S.Content>
    </Modal>
  );
};

EstimateModal.defaultProps = {
  isOpen: false,
  users: [],
};

EstimateModal.propTypes = {
  isOpen: PropTypes.bool,
  cardId: PropTypes.string,
  users: PropTypes.array,
  handleClose: PropTypes.func,
  // handleSubmit: PropTypes.func,
  // handleDelete: PropTypes.func,
};

export default EstimateModal;
